import { NgIf } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "app-horizontal-wrapper",
  templateUrl: "./horizontal-wrapper.component.html",
  styleUrls: ["./horizontal-wrapper.component.scss"],
  standalone: true,
  imports: [NgIf],
})
export class HorizontalWrapperComponent {
  /**
   * @deprecated Unused
   */
  @Input() type: string = "";
  @Input() label: string = ""; //label van het veld
  @Input() alignRight: boolean = false;
  @Input() required: boolean = false; // indien required, wordt er een * toegevoegd
  @Input() col3: boolean = false;
  @Input() marginBottom: boolean = true; // indien true, wordt er een mb-3 toegevoegd
  @Input() alignVertical: boolean = false; // indien true, centrale aligment content
  @Input() noCols?: boolean = false; // indien true, label altijd boven veld
  //@Input() isReadOnly: boolean = false;

  @Input() contentPadding = false;
}
